import { type UseQueryResult, useQuery } from 'react-query';
import {
  TransactionService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_TransactionList,
} from '../../services/wealthlane-award-services';
import { TableParamsType } from '../../types/common';

const useGetTransactionHistory = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_TransactionList | undefined,
  unknown
> => {
  const {
    approvalStatusIds,
    fromDate,
    toDate,
    taxCollectionOptions: taxCollectionStatuses,
    transferAllocateOptions: transferAllocateStatuses,
    settlementOptions: settlementStatuses,
    awardOptions: awardTypes,
    settlementTypes: settlementTypes,
    recordTypes: recordTypes,
    transactionStatus: transactionStatus,
    cancelStatusId: cancelStatusId,
    filter,
    sorting,
    skipCount,
    maxResultCount,
  } = tableInfo;
  const transactionHistory = useQuery(
    [
      'getTransactionHistory',
      approvalStatusIds,
      fromDate,
      toDate,
      taxCollectionStatuses,
      transferAllocateStatuses,
      settlementStatuses,
      awardTypes,
      settlementTypes,
      recordTypes,
      transactionStatus,
      cancelStatusId,
      filter,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      return await handleRequest(
        TransactionService.getApiAwardApiAppTransactionTransactionListForParticipant(
          approvalStatusIds,
          fromDate,
          toDate,
          taxCollectionStatuses,
          transferAllocateStatuses,
          settlementStatuses,
          awardTypes,
          settlementTypes,
          recordTypes,
          transactionStatus,
          cancelStatusId,
          undefined,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );
  return transactionHistory;
};

export default useGetTransactionHistory;
